{
  "newFeature": "现在，应用程序切换进行了简化，将在一个列表中，仅显示为您启用的应用程序。",
  "newLayout": "新布局",
  "ok": "确定"
}
